module.exports = __webpack_public_path__ + "static/media/06.d8f22d26.jpg";